export const GetBorrow = ({ basketOwnerId, coinId }) =>
  `/Inv_Basket/GetBorrow?BasketOwnerId=${basketOwnerId}&CoinId=${coinId}`;

export const GetBorrowAmountMax = ({ basketOwnerId, coinId }) =>
  `/Inv_Basket/GetBorrowAmountMax?BasketOwnerId=${basketOwnerId}&CoinId=${coinId}`;

export const BorrowInsert =
  "/Inv_Basket/BorrowInsert";
